"use client";
import axios from "axios";
import { getUserFromToken } from "../helpers/UserToken.jsx";
// import { token } from "../pages/_app";
// import CryptoJS from "crypto-js";

// console.log("process.env.NEXT_PUBLIC_API_PUBLIC_TOKEN-", process.env.NEXT_PUBLIC_API_PUBLIC_TOKEN)
// console.log("process.env.NEXT_PUBLIC_API_PUBLIC_TOKEN-", process.env.DS_CRYPTO_JS_ENCRYPTION_KEY)
let encryptedPass = ""
let encodeToken = sessionStorage.getItem("token")

export const axiosWrapper = {
    post,
    get,
    deleteMethod,
    putMethod,
    encodeToken
};


async function post(endpoint, payload) {

    try {
        const { data } = await axios({
            method: "POST",
            url: endpoint.startsWith("http") ? endpoint : `${import.meta.env.VITE_BASE_URL}${endpoint}`,
            headers: {
                "X-Custom-Authorization": encodeToken,
            },
            data: payload,
        });
        return data;
    } catch (err) {
        return {
            isError: true,
            error: err
        }
    }
}

async function get(endpoint) {
    // if (isVerfied == false) {
    //     alert("Kindly complete your KYC..")
    //     return
    // }

    try {
        const { data } = await axios({
            method: "GET",
            url: endpoint.startsWith("http") ? endpoint : `${import.meta.env.VITE_BASE_URL}${endpoint}`,
            headers: {
                "X-Custom-Authorization": encodeToken,
            }
        });
        return data;
    } catch (err) {
        return {
            isError: true,
            error: err
        }
    }
}

async function putMethod(endpoint, payload) {

    try {
        const { data } = await axios({
            method: "PUT",
            url: endpoint.startsWith("http") ? endpoint : `${import.meta.env.VITE_BASE_URL}${endpoint}`,
            headers: {
                "X-Custom-Authorization": encodeToken,
            },
            data: payload,
        });
        return data;
    } catch (err) {
        return {
            isError: true,
            error: err
        }
    }
}


async function deleteMethod(endpoint) {

    try {
        const { data } = await axios({
            method: "DELETE",
            url: endpoint.startsWith("http") ? endpoint : `${import.meta.env.VITE_BASE_URL}${endpoint}`,
            headers: {
                "X-Custom-Authorization": encodeToken,

            }
        });
        return data;
    } catch (err) {
        return {
            isError: true,
            error: err
        }
    }
}

